import { gql } from "@apollo/client";

export const QUERY_SCHOOL_METRICS_REPORT = gql`
  query (
      $schoolIds: [ID], 
      $selectedFields: [String],
    ) {
    schoolMetricsReport(
      schoolIds: $schoolIds, 
      selectedFields: $selectedFields
    ) {
      success
      message
      reportDataJson
    }
  }
`;
